import React from 'react';
export function Footer() {
  return <footer className="border-t border-slate-200 bg-white px-4 py-8 text-center text-sm text-slate-500" data-id="element-89" data-mp="32wd2cf6gdjt0">
      © {new Date().getFullYear()} Mega Pack Historia 360 — Todos los derechos
      reservados.
    </footer>;
}